import { all, put, call, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import api from '~/services/api';
// import history from '~/services/history';
import { updateUserSuccess, failure } from './actions';
// import ws from '~/services/webSocket';

export function* updateUser({ payload }) {
  try {
    const { name, email, time_id, ...rest } = payload.data;

    const profile = {
      name,
      email,
      time_id,
      ...(rest.oldPassword ? rest : {}),
    };

    const response = yield call(api.put, '/perfil', profile);
    // ws.close();
    yield put(updateUserSuccess(response.data));

    toast.success('Perfil editado com sucesso');
    window.open('/dashboard', '_self');
  } catch (error) {
    yield put(failure());
    toast.error('Erro ao editar perfil');
  }
}

export default all([takeLatest('@user/UPDATE_USER_REQUEST', updateUser)]);
